import { NoDataAvailableWarning } from "components/NoDataAvailableDiv";
import React from "react";
import CompanyAndEmailAddressSearch from "./CompanyAndEmailAddressSearch";
import EmailAddressSearch from "./EmailAddressSearch";
import { getCultureFromLcid } from "utilities/enumutils";

interface Props {
  hasNoCompany?: boolean
  onContactSelected: (contact: server.dto.ContactAddressBookEntry, culture: server.dto.Culture, email: string, company: server.dto.CompanySmall) => void
  suggestedApiInstruction: server.dto.ListContactAddressBookToItemInstruction
}

const SelectContact = (props: Props) => {
  const onContactClick = async (entry: server.dto.ContactAddressBookEntry, email: string, company?: server.dto.CompanySmall) => {
    props.onContactSelected(entry, getCultureFromLcid(entry.culture), email, company);
  };

  const SearchComponent = props.hasNoCompany ? EmailAddressSearch : CompanyAndEmailAddressSearch;

  return <SearchComponent
    suggestedApiInstruction={props.suggestedApiInstruction}
    onContactClick={onContactClick}
  >
    <div>
      <NoDataAvailableWarning>
        {RESX.Address.SelectAContactFromAddressBook}
      </NoDataAvailableWarning>
    </div>
  </SearchComponent>;
};

export default SelectContact;